import { SvgIconProps } from "../types";
//src={`/img/svg/${src}`}
export const SvgIcon = ({ src, width, height, alt }: SvgIconProps) => (
  <img src={src} alt={alt || src} width={width} height={height} draggable="false" decoding="async" loading="lazy"/>
);
